import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { useSelector } from "react-redux";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcReading } from "react-icons/fc";

const ViewHandover = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((store) => store.login.user);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/handOver/getHandOverById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting handover!");
        }
        setLoading(false);
      })

      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  // useEffect(() => {
  //   if (data) {
  //     if (data?.northSouthMeasurmentPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.northSouthMeasurmentPhoto,
  //         "northSouthMeasurmentPhoto"
  //       );
  //     }
  //     if (data?.eastWestMeasurmentPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.eastWestMeasurmentPhoto,
  //         "eastWestMeasurmentPhoto"
  //       );
  //     }

  //     if (data?.descriptionVideo) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.descriptionVideo,
  //         "descriptionVideo"
  //       );
  //     }
  //     if (data?.aFramePhoto) {
  //       getUplodedImage(setImageUrls, data?.aFramePhoto, "aFramePhoto");
  //     }
  //     if (data?.netCupPhoto) {
  //       getUplodedImage(setImageUrls, data?.netCupPhoto, "netCupPhoto");
  //     }
  //     if (data?.aFrameFoundationPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.aFrameFoundationPhoto,
  //         "aFrameFoundationPhoto"
  //       );
  //     }
  //     if (data?.ventOpenerPhoto) {
  //       getUplodedImage(setImageUrls, data?.ventOpenerPhoto, "ventOpenerPhoto");
  //     }
  //     if (data?.aluminiumShadeNetPullyPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.aluminiumShadeNetPullyPhoto,
  //         "aluminiumShadeNetPullyPhoto"
  //       );
  //     }
  //     if (data?.exhaustFanPhoto) {
  //       getUplodedImage(setImageUrls, data?.exhaustFanPhoto, "exhaustFanPhoto");
  //     }
  //     if (data?.cellusePadPhoto) {
  //       getUplodedImage(setImageUrls, data?.cellusePadPhoto, "cellusePadPhoto");
  //     }
  //     if (data?.waterPumpPhoto) {
  //       getUplodedImage(setImageUrls, data?.waterPumpPhoto, "waterPumpPhoto");
  //     }
  //     if (data?.waterPumpDrainagePhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.waterPumpDrainagePhoto,
  //         "waterPumpDrainagePhoto"
  //       );
  //     }
  //     if (data?.oxigenationPumpPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.oxigenationPumpPhoto,
  //         "oxigenationPumpPhoto"
  //       );
  //     }
  //     if (data?.uvLightPhoto) {
  //       getUplodedImage(setImageUrls, data?.uvLightPhoto, "uvLightPhoto");
  //     }
  //     if (data?.diskFilterPhoto) {
  //       getUplodedImage(setImageUrls, data?.diskFilterPhoto, "diskFilterPhoto");
  //     }
  //     if (data?.sandFilterPhoto) {
  //       getUplodedImage(setImageUrls, data?.sandFilterPhoto, "sandFilterPhoto");
  //     }
  //     if (data?.foggerAssemblyPhoto) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.foggerAssemblyPhoto,
  //         "foggerAssemblyPhoto"
  //       );
  //     }
  //     if (data?.customerFeedbackVideo) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.customerFeedbackVideo,
  //         "customerFeedbackVideo"
  //       );
  //     }
  //     if (data?.customerPhotoWithSetUp) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.customerPhotoWithSetUp,
  //         "customerPhotoWithSetUp"
  //       );
  //     }

  //     if (data?.handOverCertificate) {
  //       getUplodedImage(
  //         setImageUrls,
  //         data?.handOverCertificate,
  //         "handOverCertificate"
  //       );
  //     }
  //   }
  // }, [data]);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcReading className="fs-2 me-1" />
                  Project Handover
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Handover</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Project</label>
                  <div className="w-100 col">
                    {(data?.clientName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Handover date</label>
                  <div className="w-100 col">
                    {(data?.handOverDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Site Inspection
                  </label>
                  <div className="w-100 col">
                    {(data?.siteManagerName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              <hr></hr>
              <h1 className="text-center">Client Section</h1>
              <hr></hr>

              <div className="row mb-3">
                <div className="col-md-6">
                  <h3>Handover Document Photo (Signed by Client)</h3>
                  {/* <img
                    src={data?.handOverCertificate}
                    style={{ height: "500px", width: "500px" }}
                    className="img-fluid rounded border"
                    alt="Handover Document Photo (Signed by Client)"
                  /> */}
                  {data?.handOverCertificate ? (
                    <LazyImageComponent
                      style={{ height: "500px", width: "500px" }}
                      width="70%"
                      src={data?.handOverCertificate}
                      alt="Handover Document Photo (Signed by Client)"
                    />
                  ) : (
                    "N/A"
                  )}
                </div>
                <div className="col-md-6">
                  <h3>Client Photo with Handover Document.</h3>
                  {/* <img
                    src={data?.customerPhotoWithSetUp}
                    style={{ height: "500px", width: "500px" }}
                    className="img-fluid rounded border"
                    alt="Client Photo with Handover Document"
                  /> */}
                  {data?.customerPhotoWithSetUp ? (
                    <LazyImageComponent
                      style={{ height: "500px", width: "500px" }}
                      width="70%"
                      src={data?.customerPhotoWithSetUp}
                      alt="Client Photo with Handover Document"
                    />
                  ) : (
                    "N/A"
                  )}
                </div>
              </div>
              <hr></hr>
              <div>
                <div className="row mb-4">
                  <div className="col-12">
                    <h3>Client Feedback Video</h3>
                    {/* {data?.ceaOutsideAssemblyVideo && (
                      <img
                        src={data?.ceaOutsideAssemblyVideo}
                        alt="CEA outside assembly video (1Min max)"
                        style={{ width: "500px", height: "500px" }}
                        className="img-fluid rounded border"
                      />
                    )} */}
                    {data?.customerFeedbackVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.customerFeedbackVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Client Feedback Video"
                    )}
                  </div>
                </div>
              </div>

              <hr></hr>
              <h1 className="text-center">CEA</h1>
              <hr></hr>
              <div className="container">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA ACF Photo</h3>
                    <img
                      src={data?.CEA?.ceaAcfPhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA ACF Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Weedmat Photo</h3>
                    <img
                      src={data?.CEA?.ceaWeedmatPhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Weedmat Photo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA Gutter Side Photo</h3>
                    <img
                      src={data?.CEA?.ceaGutterSidePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Gutter Side Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Cabin Outside Photo</h3>
                    <img
                      src={data?.CEA?.ceaCabinOutsidePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Cabin Outside Photo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA Shade Net Open Photo</h3>
                    <img
                      src={data?.CEA?.ceaShadeNetOpenPhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Shade Net Open Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Non-Gutter Side Photo</h3>
                    <img
                      src={data?.CEA?.ceaNonGutterSidePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Non-Gutter Side Photo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA Shade Net Closed Photo</h3>
                    <img
                      src={data?.CEA?.ceaShadeNetClosedPhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Shade Net Closed Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Side 1 Vent Handle Photo</h3>
                    <img
                      src={data?.CEA?.ceaSide1VentHandlePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Side 1 Vent Handle Photo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA Side 2 Vent Handle Photo</h3>
                    <img
                      src={data?.CEA?.ceaSide2VentHandlePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Side 2 Vent Handle Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Side 3 Vent Handle Photo</h3>
                    <img
                      src={data?.CEA?.ceaSide3VentHandlePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Side 3 Vent Handle Photo"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>CEA Side 4 Vent Handle Photo</h3>
                    <img
                      src={data?.CEA?.ceaSide4VentHandlePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Side 4 Vent Handle Photo"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>CEA Outside Non-Gutter Side Photo</h3>
                    <img
                      src={data?.CEA?.ceaOutsideNonGutterSidePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Outside Non-Gutter Side Photo"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <h3>CEA Outside Gutter Side Photo</h3>
                    <img
                      src={data?.CEA?.ceaOutsideGutterSidePhoto}
                      style={{ height: "500px", width: "500px" }}
                      className="img-fluid rounded border"
                      alt="CEA Outside Gutter Side Photo"
                    />
                  </div>
                </div>
              </div>

              <hr></hr>
              <h1 className="text-center">Fogger Assembly</h1>
              <hr></hr>

              <div className="container">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Fogger Tank</h3>
                    <img
                      src={data?.Fogger?.foggerTankPhoto}
                      className="img-fluid rounded border"
                      alt="Fogger Tank"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>Fogger Motor</h3>
                    <img
                      src={data?.Fogger?.foggerMotorPhoto}
                      className="img-fluid rounded border"
                      alt="Fogger Motor"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Fogger Timer</h3>
                    <img
                      src={data?.Fogger?.foggerTimerPhoto}
                      className="img-fluid rounded border"
                      alt="Fogger Timer"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>Fogger On State</h3>
                    <img
                      src={data?.Fogger?.foggerOnStatePhoto}
                      className="img-fluid rounded border"
                      alt="Fogger On State"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Fogger TakeOff </h3>
                    <img
                      src={data?.Fogger?.foggerTakeOffPhoto}
                      className="img-fluid rounded border"
                      alt="Fogger Take Off"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>Fogger Disk Filter </h3>
                    <img
                      src={data?.Fogger?.foggerDiskFilterPhoto}
                      className="img-fluid rounded border"
                      alt="Fogger Disk Filter"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>
              </div>

              <hr></hr>
              <h1 className="text-center">Flatbed (Hydroponics)</h1>
              <hr></hr>

              <div className="container">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Flatbed Frame</h3>

                    <img
                      src={data?.Flatbed?.flatbedFramePhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Frame"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Flatbed Pipes</h3>

                    <img
                      src={data?.Flatbed?.flatbedPipesPhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Pipes"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Flatbed Timer</h3>

                    <img
                      src={data?.Flatbed?.flatbedTimerPhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Timer"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Flatbed Netcup</h3>

                    <img
                      src={data?.Flatbed?.flatbedNetcupPhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Netcup"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Flatbed Water Pump</h3>
                    <img
                      src={data?.Flatbed?.flatbedWaterPumpPhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Water Pump"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Flatbed Water Tank</h3>

                    <img
                      src={data?.Flatbed?.flatbedWaterTankPhoto}
                      className="img-fluid rounded border"
                      alt="Flatbed Water Tank"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Water Flow from RO Pipe</h3>

                    <img
                      src={data?.Flatbed?.flatbedWaterFlowFromRoPipePhoto}
                      className="img-fluid rounded border"
                      alt="Water Flow from RO Pipe"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Water Tank Inlet Valve</h3>

                    <img
                      src={data?.Flatbed?.flatbedWaterTankInletValvePhoto}
                      className="img-fluid rounded border"
                      alt="Water Tank Inlet Valve"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <h3>Water Recollection Pipe</h3>

                    <img
                      src={data?.Flatbed?.flatbedWaterRecollectionPipePhoto}
                      className="img-fluid rounded border"
                      alt="Water Recollection Pipe"
                      style={{ height: "500px", width: "500px" }}
                    />
                  </div>
                </div>
              </div>

              <hr></hr>
              <h1 className="text-center">Growbags (Hydroponics)</h1>
              <hr></hr>

              <div className="container">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbag J Hook</h3>

                    <img
                      src={data?.Growbags?.growbagJHookPhoto}
                      alt="Growbag J Hook"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Growbags Tank</h3>

                    <img
                      src={data?.Growbags?.growbagsTankPhoto}
                      alt="Growbags Tank"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbags Motor</h3>

                    <img
                      src={data?.Growbags?.growbagsMotorPhoto}
                      alt="Growbags Motor"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Growbags Timer</h3>

                    <img
                      src={data?.Growbags?.growbagsTimerPhoto}
                      alt="Growbags Timer"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbags On State</h3>

                    <img
                      src={data?.Growbags?.growbagsOnStatePhoto}
                      alt="Growbags On State"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Growbags Take Off</h3>

                    <img
                      src={data?.Growbags?.growbagsTakeOffPhoto}
                      alt="Growbags Take Off"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbag Trellising</h3>

                    <img
                      src={data?.Growbags?.growbagTrellisingPhoto}
                      alt="Growbag Trellising"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Growbags Disk Filter</h3>

                    <img
                      src={data?.Growbags?.growbagsDiskFilterPhoto}
                      alt="Growbags Disk Filter"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbags Drip Pipe End</h3>

                    <img
                      src={data?.Growbags?.growbagsDripPipeEndPhoto}
                      alt="Growbags Drip Pipe End"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>

                  <div className="col-md-6">
                    <h3>Growbags Arrow Dripper</h3>

                    <img
                      src={data?.Growbags?.growbagsArrowDripperPhoto}
                      alt="Growbags Arrow Dripper"
                      style={{ width: "500px", height: "500px" }}
                      className="img-fluid rounded border"
                    />
                  </div>
                </div>
              </div>

              <hr></hr>
              <h1 className="text-center">Video Section</h1>
              <hr></hr>
              <div className="container">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>CEA outside assembly video (1Min max)</h3>
                    {/* {data?.ceaOutsideAssemblyVideo && (
                      <img
                        src={data?.ceaOutsideAssemblyVideo}
                        alt="CEA outside assembly video (1Min max)"
                        style={{ width: "500px", height: "500px" }}
                        className="img-fluid rounded border"
                      />
                    )} */}
                    {data?.ceaOutsideAssemblyVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.ceaOutsideAssemblyVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "CEA outside assembly video (1Min max)"
                    )}
                  </div>

                  <div className="col-md-6">
                    <h3>Side Vent Operating video (1Min max)</h3>
                    {data?.sideVentOperatingVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.sideVentOperatingVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Side Vent Operating video (1Min max)"
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Entering inside CEA video (1Min max)</h3>
                    {data?.enteringInsideCeaVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.enteringInsideCeaVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Entering inside CEA video (1Min max)"
                    )}
                  </div>

                  <div className="col-md-6">
                    <h3>Flatbed Entire Assembly video (1Min max)</h3>

                    {data?.flatbedEntireAssemblyVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.flatbedEntireAssemblyVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Flatbed Entire Assembly video (1Min max)"
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Growbags Entire Assembly video (1Min max)</h3>

                    {data?.growbagsEntireAssemblyVideo ? (
                      <video
                        controls
                        style={{ height: "500px", width: "500px" }}
                      >
                        <source
                          src={data?.growbagsEntireAssemblyVideo}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      "Growbags Entire Assembly video (1Min max)"
                    )}
                  </div>
                </div>
              </div>
              <hr></hr>

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    North south measurment in meter
                  </label>
                  <div className="w-100 col">
                    {(data?.northSouthMeasurmentInMeter || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    North south measurment photo
                  </label>
                  <div className="w-100 col">
                    {data.northSouthMeasurmentPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data.northSouthMeasurmentPhoto}
                        alt={"north South Measurment Photo"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    East west measurment in meter
                  </label>
                  <div className="w-100 col">
                    {(data?.eastWestMeasurmentInMeter || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    East west measurment photo
                  </label>
                  <div className="w-100 col">
                    {data?.eastWestMeasurmentPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.eastWestMeasurmentPhoto}
                        alt={"east West Measurment Photo"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}

              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Description video
                  </label>
                  <div className="w-100 col">
                    {data?.descriptionVideo ? (
                      <video width="70%" controls>
                        <source src={data?.descriptionVideo} type="video/mp4" />
                      </video>
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Tank photo</label>
                  <div className="w-100 col">
                    {data?.overheadTankPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.overheadTankPhoto}
                        alt={"over head Tank Photo"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">A-Frame photo</label>
                  <div className="w-100 col">
                    {data?.aFramePhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.aFramePhoto}
                        alt={"aFramePhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Net-Cup photo</label>
                  <div className="w-100 col">
                    {data?.netCupPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.netCupPhoto}
                        alt={"netCupPhoto"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    A-Frame foundation photo
                  </label>
                  <div className="w-100 col">
                    {data?.aFrameFoundationPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.aFrameFoundationPhoto}
                        alt={"aFrameFoundationPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vent opener photo
                  </label>
                  <div className="w-100 col">
                    {data?.ventOpenerPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.ventOpenerPhoto}
                        alt={"ventOpenerPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Aluminium shadenet pully photo
                  </label>
                  <div className="w-100 col">
                    {data?.aluminiumShadeNetPullyPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.aluminiumShadeNetPullyPhoto}
                        alt={"aluminiumShadeNetPullyPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Exhaust fan photo
                  </label>
                  <div className="w-100 col">
                    {data?.exhaustFanPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.exhaustFanPhoto}
                        alt={"exhaustFanPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Celluse pad photo
                  </label>
                  <div className="w-100 col">
                    {data?.cellusePadPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.cellusePadPhoto}
                        alt={"cellusePadPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water pump photo
                  </label>
                  <div className="w-100 col">
                    {data?.waterPumpPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.waterPumpPhoto}
                        alt={"waterPumpPhoto"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Water pump drainage photo
                  </label>
                  <div className="w-100 col">
                    {data?.waterPumpDrainagePhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.waterPumpDrainagePhoto}
                        alt={"waterPumpDrainagePhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Oxigenation pump photo
                  </label>
                  <div className="w-100 col">
                    {data?.oxigenationPumpPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.oxigenationPumpPhoto}
                        alt={"oxigenationPumpPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    UV light photo
                  </label>
                  <div className="w-100 col">
                    {data?.uvLightPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.uvLightPhoto}
                        alt={"uvLightPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Disk filter photo
                  </label>
                  <div className="w-100 col">
                    {data?.diskFilterPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.diskFilterPhoto}
                        alt={"diskFilterPhoto"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Sand filter photo
                  </label>
                  <div className="w-100 col">
                    {data?.sandFilterPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.sandFilterPhoto}
                        alt={"sandFilterPhoto"}
                        style={{ height: "300px", width: "300px" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Fogger assembly photo
                  </label>
                  <div className="w-100 col">
                    {data?.foggerAssemblyPhoto ? (
                      <LazyImageComponent
                        width="70%"
                        src={data?.foggerAssemblyPhoto}
                        alt={"foggerAssemblyPhoto"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )} */}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                process.env.REACT_APP_ROLE_ADMIN_S === user.Role ||
                process.env.REACT_APP_ROLE_PURCHASE === user.Role || process.env.REACT_APP_ROLE_SALLE_ADMIN === user.Role ? (
                  <SimpleButton
                    buttonText="Edit Handover"
                    href={`/client-project-handover/edit/${id}`}
                  />
                ) : (
                  <></>
                )}
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewHandover;
